<template>
	<label ref="label" :class="`omapi-${type}`" :title="titleTag">
		<slot name="description"></slot>
		<input
			ref="input"
			v-bind="$attrs"
			:type="type"
			:value="value"
			:name="name"
			:checked="checked || selected"
			@keydown.space="$emit('input', $event)"
			v-on="$listeners"
		/>
		<span :class="fauxInputClass"></span>
		<slot>{{ label }}</slot>

		<span v-if="$slots.help || help" :class="`omapi-${type}__helper`">
			<slot name="help">
				{{ help }}
			</slot>
		</span>
	</label>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		/**
		 * The input radio type
		 */
		type: {
			type: String,
			default: 'radio',
		},
		/**
		 * The label value for the selectable input.
		 * Can optionally use the slot.
		 */
		label: {
			type: String,
			default: '',
		},
		/**
		 * Optional help text for this option.
		 * Can optionally use the help slot.
		 */
		help: {
			type: String,
			default: '',
		},
		/**
		 * Optional title tag text for this option label.
		 */
		titleTag: {
			type: String,
			default: '',
		},
		/**
		 * The name for this option.
		 */
		name: {
			type: String,
			default: '',
		},
		/**
		 * The value for this option.
		 */
		value: {
			type: String,
			default: '',
		},
		/**
		 * Additional classes for `omapi-${type}__input`
		 */
		inputClass: {
			type: String,
			default: '',
		},
		/**
		 * Wether this option is checked/selected (they both work)
		 */
		checked: Boolean,
		/**
		 * Wether this option is checked/selected (they both work)
		 */
		selected: Boolean,
	},
	computed: {
		fauxInputClass() {
			let classes = `omapi-${this.type}__input`;

			if (this.inputClass) {
				classes += ' ' + this.inputClass;
			}

			return classes;
		},
	},
};
</script>
